import { render, staticRenderFns } from "./VisitorBanModal.vue?vue&type=template&id=4aa77634&scoped=true"
import script from "./VisitorBanModal.vue?vue&type=script&lang=js"
export * from "./VisitorBanModal.vue?vue&type=script&lang=js"
import style0 from "./VisitorBanModal.vue?vue&type=style&index=0&id=4aa77634&prod&lang=scss&scoped=true"
import style1 from "./VisitorBanModal.vue?vue&type=style&index=1&id=4aa77634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa77634",
  null
  
)

export default component.exports